module.exports = __webpack_public_path__ + "img/NavigationBarWhite@2x.57033788.png";